import { LatLngExpression, LatLngLiteral } from 'leaflet';
import { useEffect, useState } from 'react';
import { getPolylineFromGoogleMapsDirectionsResponse } from '../../../services/leafletUtils';
import { Polyline } from 'react-leaflet';
import { useGoogleMaps } from '../../../contexts/GoogleMapsProvider';
import { useTheme } from '@mui/material';

interface DirectionsProps {
  origin?: LatLngLiteral;
  destination?: LatLngLiteral;
}

const Directions = ({ origin, destination }: DirectionsProps) => {
  const theme = useTheme();
  const { core, getDirections } = useGoogleMaps();
  const [points, setPoints] = useState<LatLngExpression[][]>([]);

  useEffect(() => {
    if (!origin || !destination || !core) return;

    let unmounted = false;

    getDirections(
      new core.LatLng(origin.lat, origin.lng),
      new core.LatLng(destination.lat, destination.lng),
    ).then((response) => {
      if (!unmounted && response) {
        setPoints(getPolylineFromGoogleMapsDirectionsResponse(response));
      }
    });

    return () => {
      unmounted = true;
    };
  }, [origin, destination, core, getDirections]);

  if (!origin || !destination || !points?.length) return null;

  return (
    <Polyline
      pathOptions={{ color: theme.palette.primary.main }}
      positions={points}
    />
  );
};

export default Directions;
